import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { BaseOrganizationViewmodel } from 'edu-application/dist/organization/base/base.organization.viewmodel';
import { UserInfoResponse } from 'edu-auth/dist/responses/user-info-response';
import { LoginService } from 'src/app/login/login.service';
import { OrgSwitchService } from 'src/app/shared/org-switch/org-switch.service';
import { OrganizationService } from 'src/app/shared/organization.service';

@Component({
  selector: 'profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileButtonComponent implements OnInit {
  name: string;
  info: UserInfoResponse;
  orgsLoading = false;

  readonly organizations$ = this._orgService.organizations$;

  constructor(
    private _loginService: LoginService,
    private _router: Router,
    private _orgService: OrganizationService,
    private _orgSwitchService: OrgSwitchService,
  ) {}

  ngOnInit(): void {
    this.info = this._loginService.userInfo;
    this.name = this.info.fullName;
  }

  get isTeamMember(): boolean {
    return this.info?.type === 'team';
  }

  get hasMultipleOrganizations(): boolean {
    return this._orgService.hasMultipleOrganizations;
  }

  get currentOrganizationId(): string {
    return this._orgService.currentOrganizationId;
  }

  public get initials(): string {
    if (this.name == null) return '';
    const names = this.name.trim().split(' ');
    return names[0][0] + names[names.length - 1][0];
  }

  async onMenuOpened(): Promise<void> {
    console.log(this._orgService.hasMultipleOrganizations);
    if (!this._orgService.hasMultipleOrganizations) return;
    this.orgsLoading = true;
    await this._orgService.loadOrganizations();
    this.orgsLoading = false;
  }

  selectOrganization(org: BaseOrganizationViewmodel): void {
    this._orgSwitchService.trigger(org);
  }

  onOrgButtonHover(event: MouseEvent): void {
    const button = event.currentTarget as HTMLElement;
    const viewport = button.querySelector(
      '.org-button-viewport',
    ) as HTMLElement;
    const track = button.querySelector('.org-button-track') as HTMLElement;
    const text = track?.querySelector('.org-button-text') as HTMLElement;
    if (!viewport || !track || !text) return;
    if (text.scrollWidth <= viewport.clientWidth) return;

    const gapBefore = document.createElement('span');
    gapBefore.className = 'org-button-gap';
    gapBefore.setAttribute('aria-hidden', 'true');
    const clone = text.cloneNode(true) as HTMLElement;
    clone.setAttribute('aria-hidden', 'true');
    const gapAfter = document.createElement('span');
    gapAfter.className = 'org-button-gap';
    gapAfter.setAttribute('aria-hidden', 'true');
    track.append(gapBefore, clone, gapAfter);
    viewport.classList.add('marquee');
  }

  onOrgButtonLeave(event: MouseEvent): void {
    const button = event.currentTarget as HTMLElement;
    const viewport = button.querySelector(
      '.org-button-viewport',
    ) as HTMLElement;
    const track = button.querySelector('.org-button-track') as HTMLElement;
    viewport?.classList.remove('marquee');
    while (track && track.children.length > 1) {
      track.removeChild(track.lastChild as ChildNode);
    }
  }

  async logout() {
    // Global sign-out: on the OIDC path this redirects the browser to the AS
    // end_session endpoint itself, so navigating here too would race it.
    const redirects = this._loginService.logoutRedirects;
    await this._loginService.logoutGlobal();
    if (!redirects) {
      this._router.navigate(['/login']);
    }
  }

  async goToProfile() {
    this._router.navigate(['/portal/students/dashboard']);
  }

  navigateToChangePassword() {
    this._router.navigate(['/portal/home/change-password']);
  }
}
